import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

const DEFAULT_OPTIONS: ScrollIntoViewOptions = {
  inline: 'center',
  block: 'nearest',
  behavior: 'smooth',
};
/**
 * Takes childIndex as an input to scroll the n-th child into view when it's value changes
 */
@Directive({
  selector: '[atxScrollIntoView]',
  standalone: false,
})
export class ScrollIntoViewDirective implements OnChanges, AfterViewInit {
  /**
   * The child index is used to scroll into view the n-th child of the element.
   */
  @Input() public childIndex?: number;

  /**
   * Arguments to pass into native scrollIntoView method
   * Defaults to { inline: 'center', block: 'nearest', behavior: 'smooth' }
   */
  @Input() public atxScrollIntoView?: boolean | ScrollIntoViewOptions;

  /**
   * Timeout delay to apply after view init or child index change
   * Defaults to 0
   */
  @Input() public atxScrollDelay: number;

  /**
   * Creates a controlled version of auto scroll on boolean value
   */
  @Input() public atxScrollCondition?: boolean;

  constructor(private el: ElementRef) {}

  public ngOnChanges({ childIndex, atxScrollCondition }: SimpleChanges) {
    if (childIndex && !childIndex.firstChange) {
      this.scroll();
      return;
    }

    if (atxScrollCondition && this.atxScrollCondition) {
      this.scroll();
    }
  }

  public ngAfterViewInit() {
    this.scroll();
  }

  private scroll() {
    of(1)
      .pipe(delay(this.atxScrollDelay ?? 0))
      .subscribe(() => {
        const elementToScroll: HTMLElement | undefined =
          typeof this.childIndex === 'number'
            ? this.el.nativeElement.children[this.childIndex]
            : this.el.nativeElement;
        if (!this.checkCondition()) return;

        elementToScroll?.scrollIntoView(
          this.atxScrollIntoView ? this.atxScrollIntoView : DEFAULT_OPTIONS,
        );
      });
  }

  private checkCondition() {
    return typeof this.atxScrollCondition === 'boolean'
      ? this.atxScrollCondition
      : true;
  }
}
